import React from "react";
import "./whatsapp-float.css";
import { WhatsApp } from "@mui/icons-material";

const WhatsAppFloat = () => {
const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  const message = isMobile
    ? "Hello, I need help on the web (mobile)."
    : "Hello, I need help on the web (desktop).";

  const whatsappUrl = `https://wa.me/94707665522?text=${encodeURIComponent(
    message
  )}`;

  return (
    <a
      href={whatsappUrl}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      {/* <img
        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
        alt="WhatsApp"
      /> */}
      <WhatsApp style={{color:'green'}} />
    </a>
  );
};

export default WhatsAppFloat;
